import { render, staticRenderFns } from "./liveMatchesTwoGift.vue?vue&type=template&id=6e07d97a&scoped=true"
import script from "./liveMatchesTwoGift.vue?vue&type=script&lang=js"
export * from "./liveMatchesTwoGift.vue?vue&type=script&lang=js"
import style0 from "./liveMatchesTwoGift.vue?vue&type=style&index=0&id=6e07d97a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e07d97a",
  null
  
)

export default component.exports